"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _TagOutlined = _interopRequireDefault(require("@ant-design/icons/TagOutlined"));

var _CloseOutlined = _interopRequireDefault(require("@ant-design/icons/CloseOutlined"));

var _ExclamationCircleOutlined = _interopRequireDefault(require("@ant-design/icons/ExclamationCircleOutlined"));

var _color = _interopRequireDefault(require("color"));

var _Currency = _interopRequireDefault(require("@meepshop/context/lib/Currency"));

var _StoreDesign = _interopRequireDefault(require("@meepshop/context/lib/StoreDesign"));

var _useCart2 = _interopRequireDefault(require("@meepshop/hooks/lib/useCart"));

var _locales = require("@meepshop/locales");

var _link = _interopRequireDefault(require("@meepshop/link"));

var _switch = _interopRequireDefault(require("@meepshop/switch"));

var _thumbnail = _interopRequireDefault(require("@meepshop/thumbnail"));

var _filter = _interopRequireDefault(require("@meepshop/utils/lib/filter"));

var _useCart3 = require("@meepshop/hooks/lib/gqls/useCart");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// typescript import
// import
require("../styles/useProductsColumns.less");

var styles = {
  "img": "store-cart-previewer__previewer-useProductsColumns__img",
  "upselling": "store-cart-previewer__previewer-useProductsColumns__upselling",
  "title": "store-cart-previewer__previewer-useProductsColumns__title",
  "offline": "store-cart-previewer__previewer-useProductsColumns__offline",
  "specs": "store-cart-previewer__previewer-useProductsColumns__specs",
  "tags": "store-cart-previewer__previewer-useProductsColumns__tags",
  "price": "store-cart-previewer__previewer-useProductsColumns__price",
  "delete": "store-cart-previewer__previewer-useProductsColumns__delete",
  "error": "store-cart-previewer__previewer-useProductsColumns__error"
}; // graphql typescript

// definition
var _default = function _default(viewer) {
  var _useTranslation = (0, _locales.useTranslation)('cart-previewer'),
      t = _useTranslation.t;

  var getLanguage = (0, _locales.useGetLanguage)();

  var _useContext = (0, _react.useContext)(_Currency["default"]),
      c = _useContext.c;

  var _useContext2 = (0, _react.useContext)(_StoreDesign["default"]),
      colors = _useContext2.colors;

  var _useCart = (0, _useCart2["default"])((0, _filter["default"])(_useCart3.useCartFragment, viewer)),
      upsertCart = _useCart.upsertCart;

  return (0, _react.useMemo)(function () {
    return {
      columns: [{
        dataIndex: ['coverImage'],
        width: 84,
        render: function render(image, _ref) {
          var productId = _ref.productId,
              type = _ref.type,
              status = _ref.status,
              product = _ref.product;
          var disabled = type !== 'PRODUCT' || ['DISCONTINUED', 'NOT_AVAILABLE'].includes(status || '');

          var _ref2 = product || {},
              displayToggle = _ref2.displayToggle;

          return /*#__PURE__*/_react["default"].createElement(_switch["default"], {
            isTrue: !disabled && Boolean(displayToggle === null || displayToggle === void 0 ? void 0 : displayToggle.isDisplayOnProductPage),
            render: function render(children) {
              return /*#__PURE__*/_react["default"].createElement(_link["default"], {
                href: "/products/".concat(productId),
                target: "_blank"
              }, /*#__PURE__*/_react["default"].createElement("a", {
                href: "/products/".concat(productId)
              }, children));
            }
          }, /*#__PURE__*/_react["default"].createElement(_thumbnail["default"], {
            image: image,
            size: 72,
            mobileSize: 80,
            className: "".concat(styles.img, " ").concat(status !== 'NOT_AVAILABLE' ? '' : styles.offline)
          }));
        }
      }, {
        dataIndex: ['title'],
        width: '100%',
        render: function render(title, _ref3) {
          var productId = _ref3.productId,
              specs = _ref3.specs,
              discountAllocations = _ref3.discountAllocations,
              type = _ref3.type,
              status = _ref3.status,
              product = (0, _objectWithoutProperties2["default"])(_ref3, ["productId", "specs", "discountAllocations", "type", "status"]);
          var retailPrice = product.unitPrice || 0;
          var quantity = product.quantity || 0;
          var disabled = type !== 'PRODUCT' || ['DISCONTINUED', 'NOT_AVAILABLE'].includes(status || '');

          var _ref4 = product.product || {},
              displayToggle = _ref4.displayToggle;

          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, type !== 'UPSELLING_PRODUCT' ? null : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
            className: styles.upselling
          }, t('upselling-product'))), /*#__PURE__*/_react["default"].createElement(_switch["default"], {
            isTrue: !disabled && Boolean(displayToggle === null || displayToggle === void 0 ? void 0 : displayToggle.isDisplayOnProductPage),
            render: function render(children) {
              return /*#__PURE__*/_react["default"].createElement(_link["default"], {
                href: "/products/".concat(productId),
                target: "_blank"
              }, /*#__PURE__*/_react["default"].createElement("a", {
                href: "/products/".concat(productId)
              }, children));
            }
          }, /*#__PURE__*/_react["default"].createElement("span", {
            className: "".concat(styles.title, " ").concat(status !== 'NOT_AVAILABLE' ? '' : styles.offline)
          }, status === 'DISCONTINUED' ? t('product-deleted') : getLanguage(title))), !specs ? null : /*#__PURE__*/_react["default"].createElement("div", {
            className: "".concat(styles.specs, " ").concat(status !== 'NOT_AVAILABLE' ? '' : styles.offline)
          }, specs.map(function (spec) {
            return getLanguage(spec === null || spec === void 0 ? void 0 : spec.title);
          }).join('/')), !(discountAllocations !== null && discountAllocations !== void 0 && discountAllocations.length) ? null : /*#__PURE__*/_react["default"].createElement("div", {
            className: styles.tags
          }, discountAllocations.map(function (activity) {
            return /*#__PURE__*/_react["default"].createElement("span", {
              key: activity === null || activity === void 0 ? void 0 : activity.activityId
            }, /*#__PURE__*/_react["default"].createElement(_TagOutlined["default"], null), /*#__PURE__*/_react["default"].createElement("span", null, getLanguage(activity === null || activity === void 0 ? void 0 : activity.title)));
          })), type === 'GIFT' ? /*#__PURE__*/_react["default"].createElement("div", {
            className: styles.price
          }, t('gift')) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, status && ['DISCONTINUED', 'NOT_AVAILABLE'].includes(status) ? null : /*#__PURE__*/_react["default"].createElement("div", {
            className: styles.price
          }, /*#__PURE__*/_react["default"].createElement("span", null, "".concat(quantity, "\xD7")), /*#__PURE__*/_react["default"].createElement("span", null, c(retailPrice))), status && ['DISCONTINUED', 'NOT_AVAILABLE', 'OUT_OF_STOCK', 'PRODUCT_VARIANT_MISMATCH'].includes(status) ? /*#__PURE__*/_react["default"].createElement("div", {
            className: styles.error
          }, /*#__PURE__*/_react["default"].createElement(_ExclamationCircleOutlined["default"], null), t(status)) : null));
        }
      }, {
        dataIndex: ['quantity'],
        width: 20,
        render: function render(quantity, _ref5) {
          var type = _ref5.type,
              productId = _ref5.productId,
              variantId = _ref5.variantId;
          return type === 'GIFT' ? null : /*#__PURE__*/_react["default"].createElement(_CloseOutlined["default"], {
            className: styles["delete"],
            onClick: function onClick() {
              return upsertCart({
                __typename: 'CartItem',
                productId: productId,
                quantity: (quantity || 0) * -1,
                variantId: variantId
              });
            }
          });
        }
      }],
      styles: "\n        .".concat(styles.upselling, " {\n          color: ").concat(colors[0], ";\n          background-color: ").concat(colors[3], ";\n        }\n        .").concat(styles.specs, " {\n          color: ").concat((0, _color["default"])(colors[3]).alpha(0.8), ";\n        }\n        .").concat(styles.tags, " > span {\n          background-color: ").concat((0, _color["default"])(colors[3]).alpha(0.1), ";\n        }\n      ")
    };
  }, [t, getLanguage, c, colors, upsertCart]);
};

exports["default"] = _default;